import Portal from 'modules/core/components/Portal'

import FileViewer from 'modules/documents/components/FileViewer'
import type { Props as FileViewerProps } from 'modules/documents/components/FileViewer'

export type ViewType = 'default' | 'invoiceDetail'

const widths: Record<ViewType, string> = {
  default: '432px',
  invoiceDetail: '550px',
}

interface Props {
  onClose: () => void
  fileViewerProps?: FileViewerProps
  beforeFileViewer?: React.ReactElement
  content?: React.ReactElement
  type?: ViewType
}

const DocumentViewerF0 = ({
  onClose,
  fileViewerProps,
  beforeFileViewer,
  content,
  type = 'default',
}: Props) => {
  return (
    <Portal onClose={onClose}>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 998,
          backgroundColor: 'var(--color-white, #fff)',
          overflowX: 'auto',
          overflowY: 'auto',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            height: '100%',
            flex: '1 1 auto',
            minWidth: '960px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              overflowX: 'auto',
              backgroundColor: 'var(--color-grey100, #f9fafb)',
            }}
          >
            {beforeFileViewer}
            <div
              style={{
                display: 'flex',
                flexGrow: 1,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {fileViewerProps && <FileViewer {...fileViewerProps} />}
            </div>
          </div>
          <div
            style={{
              width: widths[type],
              flexShrink: 0,
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {content}
          </div>
        </div>
      </div>
    </Portal>
  )
}

export default DocumentViewerF0
